import styled from "styled-components";
import { BORDER_RADIUS, COLORS, FONT_FAMILY, FONT_WEIGHT, MARGIN } from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const SectionNavigation = styled.nav`
  position: relative;
  display: flex;
  align-items: center;
  gap: 28px;
  min-height: 60px;
  padding-inline: ${MARGIN.max80};
  background: ${COLORS.Crimson};
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0 0 ${BORDER_RADIUS.radius24} ${BORDER_RADIUS.radius24};

  @media (max-width: 1370px) {
    padding-inline: ${MARGIN.fix32};
    gap: 20px;
  }

  @media (max-width: 1024px) {
    min-height: 64px;
    padding-inline: ${MARGIN.fix24};
    gap: 16px;
  }
`;

export const SectionContext = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 10px;
  color: ${COLORS.Yellow};
  padding-right: 28px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  font-family: ${FONT_FAMILY.poppins};
  font-size: 13px;
  font-weight: ${FONT_WEIGHT.semiBold};

  @media (max-width: 1024px) {
    max-width: 40%;
    padding-right: 16px;
    font-size: 12px;
    line-height: 1.4;

    svg { display: none; }
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  align-items: stretch;
  gap: 24px;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: ${COLORS.Yellow} transparent;

  @media (max-width: 1024px) { display: none; }
`;

export const Card = styled.button<{ $active: boolean; $biggerCursor: boolean }>`
  position: relative;
  flex-shrink: 0;
  min-height: 59px;
  padding: 12px 2px;
  border: 0;
  background: transparent;
  cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  white-space: nowrap;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    border-radius: 3px 3px 0 0;
    background: ${({ $active }) => $active ? COLORS.Yellow : "transparent"};
  }

  &:hover::after { background: ${COLORS.Yellow}; }
  &:focus-visible {
    outline: 2px solid ${COLORS.Yellow};
    outline-offset: -5px;
    border-radius: ${BORDER_RADIUS.radius8};
  }
`;

export const MobileMenuWrapper = styled.div`
  display: none;
  position: relative;
  z-index: 2;
  flex: 1;
  min-width: 0;

  @media (max-width: 1024px) { display: block; }
`;

export const MobileMenuButton = styled.button<{ $open: boolean; $biggerCursor: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 44px;
  padding: 8px 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: ${COLORS.AbsoluteWhite};
  font-family: ${FONT_FAMILY.poppins};
  cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  text-align: left;
  > div { min-width: 0; overflow-wrap: anywhere; }

  > svg {
    flex-shrink: 0;
    color: ${COLORS.Yellow};
    transform: ${({ $open }) => $open ? "rotate(180deg)" : "none"};
    transition: transform 150ms ease;
  }

  &:focus-visible { outline: 2px solid ${COLORS.Yellow}; outline-offset: 2px; }
`;

export const MobileMenuPanel = styled.div`
  position: absolute;
  top: calc(100% - 24px);
  left: 0;
  right: 0;
  z-index: 1;
  padding: 24px 16px 16px;
  background: ${COLORS.Crimson};
  border-radius: 0 0 ${BORDER_RADIUS.radius24} ${BORDER_RADIUS.radius24};
  box-shadow: 0 12px 20px ${COLORS.boxShadow};

  @media (min-width: 1025px) { display: none; }
`;

export const MobileMenuList = styled.ul`
  list-style: none;
  max-height: min(55vh, 360px);
  overflow-y: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  padding-top: 8px;
  scrollbar-width: thin;
  scrollbar-color: ${COLORS.Yellow} transparent;
`;

export const MobileMenuItem = styled.button<{ $active: boolean; $biggerCursor: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 48px;
  padding: 12px 16px;
  border: 0;
  border-radius: ${BORDER_RADIUS.radius8};
  background: ${({ $active }) => $active ? "rgba(255, 204, 0, 0.09)" : "transparent"};
  text-align: left;
  cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  color: ${COLORS.Yellow};

  > svg { flex-shrink: 0; }
  &:hover { background: rgba(255, 255, 255, 0.08); }
  &:focus-visible { outline: 2px solid ${COLORS.Yellow}; outline-offset: -2px; }
`;
